import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CwtAuthStoreService } from '@cawita/core-front/auth';
import { filter, take } from 'rxjs/operators';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';
import { StayStore } from './stay.store';

@Injectable({ providedIn: 'root' })
export class PartnerActiveGuard implements CanActivate {
    constructor(
        @Inject(CWT_APP_CONFIG) private appConfig: CwtAppConfig,
        private auth: CwtAuthStoreService,
        private store: StayStore,
        private router: Router
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const res = await this.store.state$.pipe(take(1), filter(s => s.initialized && !s.loading)).toPromise();
      if(res.activePartner) return true;
      if(!this.auth.isLoggedIn) return this.router.createUrlTree(this.appConfig.stay.redirectOnPartnerInactiveLoggedOut);
      return this.router.createUrlTree(this.appConfig.stay.redirectOnPartnerInactiveLoggedIn);
    }
}
